import { FaArrowUpRightFromSquare } from "react-icons/fa6";
import { Link } from "react-router-dom";
import classes from "./ProPrograms.module.css";

export default function ProPrograms({
  heading,
  highlightText,
  description,
  programs = [],
}) {
  return (
    <section className={classes.section}>
      <div className={classes.shell}>
        <div className={classes.content}>
          {/* Intro */}
          <div className={classes.intro}>
            <h2 className={classes.introHeading}>
              {heading}{" "}
              {highlightText && (
                <span className={classes.highlight}>{highlightText}</span>
              )}
            </h2>

            {description && (
              <p className={classes.introParagraph}>
                {description}
              </p>
            )}
          </div>

          {/* Programs */}
          <div className={classes.cards}>
            {programs.map((program, index) => {
              const hasLink =
                typeof program.link === "string" &&
                program.link.trim().length > 0;

              const cardContent = (
                <>
                  {hasLink && (
                    <span className={classes.programArrow} aria-hidden="true">
                      <FaArrowUpRightFromSquare />
                    </span>
                  )}

                  <h3 className={classes.programTitle}>{program.title}</h3>

                  {program.description && (
                    <p className={classes.programDescription}>
                      {program.description}
                    </p>
                  )}
                </>
              );

              if (hasLink) {
                return (
                  <Link
                    key={program.id || program.title || index}
                    to={program.link}
                    className={classes.programCard}
                    aria-label={`Learn more about ${program.title}`}
                  >
                    {cardContent}
                  </Link>
                );
              }

              return (
                <div key={program.id || program.title || index} className={classes.programCard}>
                  {cardContent}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
